import Vue from 'vue'
import Router from 'vue-router'
import header from '@/components/header'
import index from '@/components/index'
import khal from '@/components/khal'
import xwdt from '@/components/xwdt'
import lxwm from '@/components/lxwm'
import zhyy from '@/components/zhyy'
import zhfk from '@/components/zhfk'
import zhjc from '@/components/zhjc'
import jstx from '@/components/jstx'
import zwyth from '@/components/zwyth'
import news_detail from '@/components/news_detail'
import khal_detail from '@/components/khal_detail'
import NotFoundComponent from '@/components/NotFoundComponent'
import { resolve } from 'url';

Vue.use(Router)

export default new Router({
  mode:'history',
  base:'/dist/',
  routes: [
    {
      path: '/',
      component: header,
      children:[
        {
          path:"/",
          component:index,
          redirect:'index'
        },
        {
          path:"index",
          name:'index',
          component:index
        },
        {
          path:"zhyy",
          name:'zhyy',
          component:zhyy
        },
        {
          path:"zwyth",
          name:'zwyth',
          component:zwyth
        },
        {
          path:"zhfk",
          name:'zhfk',
          component:zhfk
        },
        {
          path:"zhjc",
          name:'zhjc',
          component:zhjc
        },
        {
          path:"jstx",
          name:'jstx',
          component:jstx
        },
        {
          path:"khal",
          name:'khal',
          component:khal
        },
        {
          path:"xwdt",
          name:'xwdt',
          component:xwdt
        },
        {
          path:"lxwm",
          name:'lxwm',
          component:lxwm
        },
        {
          path:"news_detail",
          name:'news_detail',
          component:news_detail
        },
        {
          path:"khal_detail",
          name:'khal_detail',
          component:khal_detail
        },
      ]
    },
    { path: '*', component: NotFoundComponent }
  ]
  //redirect:'/'
  ,
  scrollBehavior(to,from,savePosition){//跳转置顶
    return {x:0,y:0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js